import { get, prefix } from './base';

// 获取加入企业列表
export function getCompanys(params) {
  return get(prefix + 'platform/getCompanys', params);
}

// 获取财务相关信息
export function accountInfo(params) {
  return get(prefix + 'platform/accountInfo', params);
}

// 获取当前企业得应用列表
export function companyApps(params) {
  return get(prefix + 'platform/companyApps', params);
}

// 获取最近使用app列表
export function recentlyUsedApp(params) {
  return get(prefix + 'platform/recentlyUsedApp', params);
}

export function report(appName) {
  return get(prefix + `platform/report/${appName}`);
}
// 首页弹窗 判读是否第一次弹窗
export function getOptMarkStatus(params) {
  return get(prefix + 'platform/user/getOptMarkStatus', params);
}
// 点击首页弹窗保存状态
export function saveOptMark(params) {
  return get(prefix + 'platform/user/saveOptMark', params);
}
